import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cancelCircle",
  "use": "cancelCircle-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 48 48\" id=\"cancelCircle\">\n  <path d=\"M24 4a20 20 0 1 0 20 20A20 20 0 0 0 24 4m10.607 29.192-1.415 1.414L24 25.414l-9.192 9.192-1.415-1.414L22.586 24l-9.193-9.192 1.415-1.414L24 22.586l9.192-9.192 1.415 1.414L25.414 24Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol